export enum RiskCategory {
  LabourAndHumanRight = "LabourAndHumanRights",
  HealthAndSafety = "HealthAndSafety",
  BusinessIntegrity = "BusinessIntegrity",
  Environment = "Environment",
  SupplierManagement = "SupplierManagement",
}

export function riskCategoryToDescriptionText(category: RiskCategory): string {
  switch (category) {
    case RiskCategory.LabourAndHumanRight:
      return "Labour and Human Rights";
    case RiskCategory.HealthAndSafety:
      return "Health and Safety";
    case RiskCategory.BusinessIntegrity:
      return "Business Integrity";
    case RiskCategory.Environment:
      return "Environment";
    case RiskCategory.SupplierManagement:
      return "Supplier Management";
  }
}

export function getRiskCategoryColor(riskCategory: RiskCategory) {
  switch(riskCategory){
    case RiskCategory.LabourAndHumanRight:
      return "--labour-and-human-rights-color";
    case RiskCategory.HealthAndSafety:
      return "--health-and-safety-color";
    case RiskCategory.Environment:
      return "--environment-color";
    case RiskCategory.BusinessIntegrity:
      return "--business-integrity-color";
    case RiskCategory.SupplierManagement:
      return "--supplier-management-color";
  }
}
